import React from 'react';
import { Link } from 'react-router-dom';

const PuzzleGrid = ({ puzzles, onPuzzleClick }) => {
  const formatFiceScore = (fice_score) => {
    if (typeof fice_score === 'number') {
      return fice_score.toFixed(2);
    }
    return fice_score || 'N/A';
  };

  // Common content to render for each puzzle
  const PuzzleContent = ({ puzzle }) => (
    <>
      <div 
        className="puzzle-pattern" 
        style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${puzzle.pattern.length}, 1fr)`,
          gap: '1px',
          backgroundColor: 'black',
          padding: '1px'
        }}
      >
        {puzzle.pattern.flat().map((cell, index) => (
          <div 
            key={index} 
            style={{
              backgroundColor: 
                cell === 'r' ? 'red' : 
                cell === 'b' ? 'blue' : 
                cell === 'y' ? 'yellow' : 
                'black',
              aspectRatio: '1',
            }}
          />
        ))}
      </div>
      <div className="puzzle-info">
        <div className="name">{puzzle.name}</div>
        <div className="board-number">{puzzle.board_number}</div>
        {puzzle.pattern.length === 8 && (
          <div className="booklet-number">Booklet: {puzzle.booklet_number}</div>
        )}
        <div className="difficulty">{puzzle.difficulty}</div>
        <div className="fice">FICE: {formatFiceScore(puzzle.fice_score)}</div>
        <div className="num-solutions">{puzzle.num_solutions} solns</div>
      </div>
    </>
  );

  return (
    <div className="puzzle-grid">
      {puzzles.map(puzzle => {
        // If onPuzzleClick is provided, use div with click handler
        if (onPuzzleClick) {
          return (
            <div
              key={puzzle.board_number}
              className="puzzle-card"
              onClick={() => onPuzzleClick(puzzle)}
              style={{ cursor: 'pointer' }}
            >
              <PuzzleContent puzzle={puzzle} />
            </div>
          );
        }
        
        // Otherwise use Link for navigation
        return (
          <Link
            key={puzzle.board_number}
            to={`/puzzle/${puzzle.board_number}`}
            className="puzzle-card"
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <PuzzleContent puzzle={puzzle} />
          </Link>
        );
      })}
    </div>
  );
};

export default PuzzleGrid;